module.exports = __webpack_public_path__ + "static/media/personalist-orange.6716f3ec.png";